import React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    withStyles,
    createTheme,
    ThemeProvider,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = () => ({
    submit: {
        fontSize: '14px',
        fontWeight: '500',
        padding: '12px',
        borderRadius: '5px',
        fontFamily: 'Noto Sans KR',
    },
});

function CustomButton(props) {
    const { classes, label, onClick, className, disabled, variant, fullWidth, startIcon, endIcon } = props;
    const submitTheme = createTheme({
        palette: {
            primary: {
                main: '#ff6a72',
                contrastText: 'white',
            },
        },
    });

    return (
        <ThemeProvider theme={submitTheme}>
            <Button
                type="button"
                variant={variant}
                color="primary"
                fullWidth={fullWidth}
                className={clsx(classes.submit, className)}
                onClick={onClick}
                disabled={disabled}
                startIcon={startIcon}
                endIcon={endIcon}
            >
                {label}
            </Button>
        </ThemeProvider>
    );
}

CustomButton.defaultProps = {
    label: 'Button',
    disabled: false,
    className: '',
    variant: 'contained',
    onClick: () => {},
    fullWidth: true,
    startIcon: null,
    endIcon: null,
};

CustomButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    variant: PropTypes.string,
    fullWidth: PropTypes.bool,
    startIcon: PropTypes.object,
    endIcon: PropTypes.object,
};

export default withStyles(useStyles)(CustomButton);
